import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeStatus, ScorecardQuery } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScorecardDescriptionModalComponent } from '@fgb/portal-component-library/src/lib/loyalty/scorecards/scorecard-description-modal';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@fgb/core';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/pipes';

const _c0 = function (a0) { return { "badge-incomplete": a0 }; };
class BadgeListItemComponent {
    constructor(modalService, scorecardQuery) {
        this.modalService = modalService;
        this.scorecardQuery = scorecardQuery;
        this.BadgeStatus = BadgeStatus;
    }
    ngOnInit() { }
    openScorecardDescription() {
        const scorecard = this.scorecardQuery.getEntity(this.badge.ScorecardId);
        if (!scorecard) {
            return;
        }
        const modalRef = this.modalService.open(ScorecardDescriptionModalComponent, {
            centered: true,
            windowClass: 'scorecard-modal-content',
        });
        modalRef.componentInstance.scorecard = scorecard;
    }
}
BadgeListItemComponent.ɵfac = function BadgeListItemComponent_Factory(t) { return new (t || BadgeListItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ScorecardQuery)); };
BadgeListItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BadgeListItemComponent, selectors: [["fgbcl-badge-list-item"]], inputs: { badge: "badge" }, decls: 7, vars: 11, consts: [["type", "button", 1, "border-0", "bg-transparent", "w-100", "px-0", "mt-3", 3, "click"], [1, "badge-container", "d-flex", "flex-column", "justify-content-center", "align-items-center"], [1, "badge-image", "mb-3", 3, "ngClass"], ["alt", "", 3, "src", "useDefault", "loyaltyType"], [1, "badge-title", "px-1", "scorecard-label-ellipsis", "text-center"]], template: function BadgeListItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function BadgeListItemComponent_Template_button_click_0_listener() { return ctx.openScorecardDescription(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "img", 3);
        ɵngcc0.ɵɵpipe(4, "contentImage");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c0, ctx.badge.Status != ctx.BadgeStatus.Completed));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind3(4, 5, ctx.badge.Badge, "7", "badge"), ɵngcc0.ɵɵsanitizeUrl)("useDefault", true)("loyaltyType", "badge");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.badge.Content[0].Name, " ");
    } }, directives: [ɵngcc3.NgClass, ɵngcc4.ImgDefaultDirective], pipes: [ɵngcc5.ContentImagePipe], styles: [".badge-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:70px}.badge-incomplete[_ngcontent-%COMP%]{opacity:.2}.scorecard-label-ellipsis[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical}.scorecard-label-ellipsis.three-line[_ngcontent-%COMP%]{-webkit-line-clamp:3}"] });
BadgeListItemComponent.ctorParameters = () => [
    { type: NgbModal },
    { type: ScorecardQuery }
];
BadgeListItemComponent.propDecorators = {
    badge: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BadgeListItemComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-badge-list-item',
                template: "<button type=\"button\" class=\"border-0 bg-transparent w-100 px-0 mt-3\" (click)=\"openScorecardDescription()\">\r\n  <div class=\"badge-container d-flex flex-column justify-content-center align-items-center\">\r\n    <div class=\"badge-image mb-3\" [ngClass]=\"{ 'badge-incomplete': badge.Status != BadgeStatus.Completed }\">\r\n      <img [src]=\"badge.Badge | contentImage: '7':'badge'\" [useDefault]=\"true\" [loyaltyType]=\"'badge'\" alt=\"\" />\r\n    </div>\r\n    <div class=\"badge-title px-1 scorecard-label-ellipsis text-center\">\r\n      {{ badge.Content[0].Name }}\r\n    </div>\r\n  </div>\r\n</button>\r\n",
                styles: [".badge-container img{height:70px}.badge-incomplete{opacity:.2}.scorecard-label-ellipsis{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical}.scorecard-label-ellipsis.three-line{-webkit-line-clamp:3}"]
            }]
    }], function () { return [{ type: ɵngcc1.NgbModal }, { type: ɵngcc2.ScorecardQuery }]; }, { badge: [{
            type: Input
        }] }); })();

class BadgeListItemModule {
}
BadgeListItemModule.ɵfac = function BadgeListItemModule_Factory(t) { return new (t || BadgeListItemModule)(); };
BadgeListItemModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BadgeListItemModule });
BadgeListItemModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            DirectivesModule,
            PipesModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BadgeListItemModule, { declarations: function () { return [BadgeListItemComponent]; }, imports: function () { return [CommonModule,
        DirectivesModule,
        PipesModule]; }, exports: function () { return [BadgeListItemComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BadgeListItemModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    BadgeListItemComponent
                ],
                imports: [
                    CommonModule,
                    DirectivesModule,
                    PipesModule
                ],
                exports: [
                    BadgeListItemComponent
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BadgeListItemComponent, BadgeListItemModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-badges-badge-list-item.js.map